import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import GeneratorLandingPage from '@/components/generator-landing-page/GeneratorLandingPage';
import { ListBulletIcon } from '@heroicons/react/20/solid';
import {
  CircleStackIcon,
  ClipboardDocumentListIcon,
  ClipboardIcon,
  ClockIcon,
  DocumentDuplicateIcon
} from '@heroicons/react/24/solid';
import { TableCellsIcon } from '@heroicons/react/24/solid';
import overviewImage from '@/public/youtube-overview.png';

const imageSection: SectionDetails = {
  miniText: 'Optimized studying',
  title: 'Flashcards in seconds',
  image: overviewImage,
  description:
    'Enhance your learning and remember your content by instantly generating the exact flashcards you need.',
  features: [
    {
      name: 'Paste a link.',
      description:
        'Limbiks uses the available transcript from your YouTube link as input to the flashcard generator.',
      icon: ClipboardIcon
    },
    {
      name: 'Select number of flashcards.',
      description:
        'Whether you want as many as possible or just a few, specify exactly how many flashcards you want Limbiks to create.',
      icon: CircleStackIcon
    },
    {
      name: 'Multiple flashcard types.',
      description:
        'Generate question and answer or fill in the blank, and image occlusion flashcards. Choose the type that works best for you.',
      icon: TableCellsIcon
    }
  ]
};

const featureSection: SectionDetails = {
  miniText: 'Master Content',
  title: 'Supercharge Your Learning',
  description:
    'Our advanced flashcard generator leverages cutting-edge AI to transform YouTube videos into effective study tools, ensuring you grasp every detail from your favorite content. Perfect for enhancing your learning experience and making study sessions more engaging.',
  features: [
    {
      name: 'Instant Study Guides',
      description:
        'Automatically generate comprehensive study guides from any YouTube video. Our AI analyzes the video transcript to compile a focused study guide that highlights key concepts and essential information, streamlining your studying process.',
      icon: ClipboardDocumentListIcon
    },
    {
      name: 'Interactive Quiz Questions',
      description:
        'Turn your generated flashcards into interactive multiple-choice questions. This feature helps in reinforcing the material, making it easier to remember important details through active engagement.',
      icon: ListBulletIcon
    },
    {
      name: 'Optimized Review Schedule',
      description:
        'Utilize spaced repetition techniques to manage your study schedule effectively. Track due dates and ratings for each flashcard to ensure you revisit material just at the right time, boosting long-term retention.',
      icon: ClockIcon
    }
  ]
};

export default function _YoutubeToFlashcards() {
  return (
    <GeneratorLandingPage
      isYoutube
      imageSection={imageSection}
      featureSection={featureSection}
      title="YouTube to Flashcards"
      description="Paste a link to any YouTube video and generate a comprehensive deck of flashcards in seconds. Learn with our powerful study tools or download flashcards to use with any other flashcard app."
    />
  );
}
